import styled from 'styled-components'
import BodyCopy from '../BodyCopy'

export const StyledBodyCopy = styled(BodyCopy)`
  font-size: 14px;
`
